import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QrReader } from 'react-qr-reader';
import CashOutService from '../../../services/Celcoin/dinamicCashOutService';
import UtilService from '../../../services/Celcoin/utilService';
import { getTranslations } from '../../../services/languageUtils';
import AccountManagerService from '../../../services/Celcoin/accountManagerService';

class Item extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      step: 0,
      code: '',
      billInfo: {},
      paymentResult: {},
      translations: {},
      currentBalance: 0,
      show2FAModal: false,
      twoFactorCode: '',
      loading2FA: false,
      loadingVerify: false,
      loadingPayment: false,
      description: '',
      pendingStep: 0,
      openCamera: false
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  handleScan = (data) => {
    if (data) {
      this.setState({ code: data.text || data });
    }
  };

  handleError = (err) => {
    this.setState({ error: this.state.translations.errorReadingCode });
  };

  proceed = (value) => {
    const that = this;
    
    if (value === 1) {
      this.setState({ loadingVerify: true });
      
      CashOutService.verifyBill({
        detailed: true,
        barcode: this.state.code.replace(/\D/g, "")
      })
        .then((res) => {
          that.setState({
            billInfo: res.data.payment_info,
            loadingVerify: false
          });
          that.props.onChangeValue({ target: { name: 'step', value } });
        })
        .catch((err) => {
          that.setState({ loadingVerify: false });
          toast.error(that.state.translations.requestErrorCheckTheData || 'Erro ao verificar boleto', {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
          });
        });
    } else {
      this.props.onChangeValue({ target: { name: 'step', value } });
    }
  }

  sendPayment(step) {
    this.setState({
      show2FAModal: true,
      pendingStep: step,
      twoFactorCode: ''
    });
  }

  confirmPayment = () => {
    let that = this;
    
    this.setState({ loadingPayment: true });

    CashOutService.payBill({
      barcode: this.state.code.replace(/\D/g, ""),
      amount_cents: this.state.billInfo.total_amount_cents,
      document_amount_cents: this.state.billInfo.amount_cents,
      description: this.state.description || 'Pagamento de boleto'
    })
      .then((res) => {
        that.setState({
          paymentResult: res.data,
          loadingPayment: false
        });
        that.proceed(that.state.pendingStep);
      })
      .catch((err) => {
        that.setState({ loadingPayment: false });
        toast.error(that.state.translations.errorProcessingPayment || 'Erro ao processar pagamento');
      });
  }

  handleTwoFactorCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').substring(0, 6);
    this.setState({ twoFactorCode: value });
  }

  handleEnter2FA = (e) => {
    if (e.key === 'Enter' && this.state.twoFactorCode.length === 6) {
      this.verify2FAForPayment();
    }
  }

  verify2FAForPayment = async () => {
    if (this.state.twoFactorCode.length !== 6) {
      return toast.error(this.state.translations.invalidCode || 'Código deve ter 6 dígitos');
    }

    this.setState({ loading2FA: true });

    try {
      await UtilService.verify2FAForTransaction(
        sessionStorage.getItem("emailUser"), 
        this.state.twoFactorCode
      );
      
      this.setState({ 
        show2FAModal: false, 
        loading2FA: false,
        twoFactorCode: '' 
      });
      
      this.confirmPayment();
      
    } catch (error) {
      this.setState({ loading2FA: false });
      toast.error(this.state.translations.invalid2FACode || 'Código 2FA inválido');
    }
  }

  cancel2FA = () => {
    this.setState({
      show2FAModal: false,
      twoFactorCode: '',
      loading2FA: false,
      loadingPayment: false
    });
  }

  back = (value) => {
    this.props.onChangeValue({ target: { name: 'step', value } });
  };

  handleChange = (value, item) => {
    if (item === 'recipient') {
      this.setState({ code: value });
    }
  };

  componentDidMount() {
    this.loadTranslations();
    this.updateBalance();
  }

  updateBalance() {
    let that = this;
    AccountManagerService.showBalance().then((res) => {
      that.setState({currentBalance: res.data.body.amount});
    }).catch((err) => {
      console.error(err);
    });
  }

  renderCameraModal() {
    return (
      <div className="modal-overlay">
        <div className="modal">
          <button className="close-button" onClick={() => this.setState({ openCamera: false })}>X</button>
          <div className="modal-content">
            <h3>{this.state.translations.scanBarcode || 'Escaneie o Código de Barras'}</h3>
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <QrReader
                constraints={{ facingMode: 'environment' }}
                scanDelay={500}
                onResult={(result, error) => {
                  if (!!result) {
                    this.handleScan(result);
                    this.setState({ openCamera: false });
                  }
                  if (!!error) {
                    this.handleError(error);
                  }
                }}
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
   return (
    <section id="pixTransferComponent" className="pixTransferComponent" key={this.props.type}>
        {
          this.props.step === 0 &&
          <div>
            <div className="mainContent100">
              <p>
                {this.state.translations.enterBarcodeNumber || 'Digite o código de barras do boleto'}
              </p>
              <input 
                type="text" 
                onChange={(e)=>this.handleChange(e.target.value, "recipient")} 
                className="input" 
                value={this.state.code}  
                style={{maxWidth: "800px"}}
                placeholder="00000.00000 00000.000000 00000.000000 0 00000000000000"
              />

              <div className="buttonSend" onClick={() => {this.setState({openCamera: true})}}>
                {this.state.translations.openCamera || 'Abrir Câmera'}
              </div>
              
              {this.state.openCamera && this.renderCameraModal()}

              <div className={`buttonSend ${this.state.loadingVerify ? 'disabled' : ''}`} 
                   onClick={!this.state.loadingVerify ? () => {this.proceed(1)} : null}>
                {this.state.loadingVerify ? <div className="loader"></div> : (this.state.translations.verify || 'Verificar')}
              </div>
            </div>
          </div>
        }

        {
          this.props.step === 1 &&
          <div>
            <div className="mainContent">
              <p className="pTitle">
                {this.state.translations.billInfo || 'Informações do Boleto'}
              </p>

              <p className="pLabel">
                {this.state.billInfo.recipient_name}
              </p>

              <div className="contentSpaceBetween">
                <p className="labelGray">
                  {this.state.translations.value || 'Valor'}
                </p>
                <b>
                  {(this.state.billInfo.total_amount_cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </b>
              </div>
              
              {this.state.billInfo.due_date && (
                <div className="contentSpaceBetween">
                  <p className="labelGray">
                    {this.state.translations.dueDate || 'Vencimento'}
                  </p>
                  <b>
                    {new Date(this.state.billInfo.due_date).toLocaleDateString('pt-BR')}
                  </b>
                </div>
              )}

              <div className="contentSpaceBetween">
                <p className="labelGray">
                  {this.state.translations.barcode || 'Código de Barras'}
                </p>
                <b style={{fontSize: '12px', wordBreak: 'break-all'}}>
                  {this.state.billInfo.barcode}
                </b>
              </div>

              <div style={{marginTop: '20px'}}>
                <p className="labelGray">
                  {this.state.translations.description || 'Descrição (opcional)'}
                </p>
                <input 
                  type="text" 
                  value={this.state.description}
                  onChange={(e) => this.setState({description: e.target.value})}
                  className="input" 
                  placeholder={this.state.translations.paymentDescription || 'Descrição do pagamento'}
                  style={{maxWidth: "800px", marginTop: '5px'}}
                />
              </div>
              
              <br/><br/>
              <div onClick={() => {this.back(0)}} className="backButton">
                {this.state.translations.somethingWrong || 'Algo errado?'} <b>{this.state.translations.goBack || 'Voltar'}</b>
              </div>
            </div>

            <div className="mainContent" style={{ borderRadius: "0px 8px 8px 0px" }}>
              <p className="pTitle spaceBetween">
                <span>{this.state.translations.currentBalance || 'Saldo Atual'}</span>
                <span style={{ fontWeight: "700" }}>
                  {this.state.currentBalance.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </span>
              </p><br/>

              <div className={`buttonSend ${this.state.loadingPayment ? 'disabled' : ''}`} 
                   onClick={!this.state.loadingPayment ? () => {this.sendPayment(2)} : null}>
                {this.state.loadingPayment ? <div className="loader"></div> : (this.state.translations.payBill || 'Pagar Boleto')}
              </div>
            </div>
          </div>
        }
        {
          this.props.step === 2 &&
          <div>
            <div className="mainContent">
              <p className="pTitle">
                {this.state.translations.paymentCompleted || 'Pagamento Realizado'}
              </p>

              <p className="pLabel">
                {this.state.billInfo.recipient_name}
              </p>

              <div className="contentSpaceBetween">
                <p className="labelGray">
                  {this.state.translations.value || 'Valor'}
                </p>
                <b>
                  {(this.state.billInfo.total_amount_cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </b>
              </div>
              
              {this.state.paymentResult.id && (
                <div className="contentSpaceBetween">
                  <p className="labelGray">
                    {this.state.translations.transactionId || 'ID da Transação'}
                  </p>
                  <b style={{fontSize: '12px', wordBreak: 'break-all'}}>
                    {this.state.paymentResult.id}
                  </b>
                </div>
              )}

              <div className="contentSpaceBetween">
                <p className="labelGray">
                  {this.state.translations.status || 'Status'}
                </p>
                <b>
                  {this.state.paymentResult.status === 'pending' ? 'Pendente' : this.state.paymentResult.status}
                </b>
              </div>
              
              <br/>
            </div>

            <div className="mainContent" style={{borderRadius: "0px 8px 8px 0px", textAlign: "center"}}>
              <br/><br/>
              <b>
                <img src={require("../../../assets/imgs/ico-higher-bg.svg").default} alt={this.state.translations.success_icon_alt} className="imgSuccess" />
                {this.state.translations.paymentCompletedSuccessfully || 'Pagamento realizado com sucesso!'}
              </b><br/><br/>
              <div className="buttonShare" style={{cursor: "pointer"}} onClick={() => {this.proceed(0)}}>
                {this.state.translations.newPayment || 'Novo Pagamento'}
              </div>
            </div>
          </div>
        }

        {this.state.show2FAModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                padding: "24px",
                minWidth: "350px",
                maxWidth: "90%",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "8px", color: "#333" }}>
                {this.state.translations.twoFactorAuthentication || 'Autenticação de Dois Fatores'}
              </h3>
              <p style={{ fontSize: "14px", color: "#666", marginBottom: "20px" }}>
                {this.state.translations.enterCodeFromApp || 'Digite o código de 6 dígitos do seu aplicativo autenticador:'}
              </p>
              
              <input
                type="text"
                value={this.state.twoFactorCode}
                onChange={this.handleTwoFactorCodeChange}
                onKeyDown={this.handleEnter2FA}
                maxLength="6"
                placeholder="000000"
                disabled={this.state.loading2FA}
                style={{
                  width: "100%",
                  padding: "12px",
                  fontSize: "18px",
                  textAlign: "center",
                  letterSpacing: "4px",
                  border: "2px solid #ddd",
                  borderRadius: "6px",
                  margin: "16px 0",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
              
              <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "20px" }}>
                <button 
                  onClick={this.cancel2FA}
                  disabled={this.state.loading2FA}
                  style={{
                    backgroundColor: "white",
                    border: "1px solid #aaa",
                    color: "#555",
                    borderRadius: "6px",
                    padding: "10px 20px",
                    cursor: this.state.loading2FA ? "not-allowed" : "pointer",
                    opacity: this.state.loading2FA ? 0.6 : 1,
                  }}
                >
                  {this.state.translations.cancel || 'Cancelar'}
                </button>
                <button 
                  onClick={this.verify2FAForPayment}
                  disabled={this.state.loading2FA || this.state.twoFactorCode.length !== 6}
                  style={{
                    backgroundColor: this.state.loading2FA || this.state.twoFactorCode.length !== 6 ? "#ccc" : "#1c787e",
                    border: "none",
                    color: "white",
                    borderRadius: "6px",
                    padding: "10px 20px",
                    cursor: this.state.loading2FA || this.state.twoFactorCode.length !== 6 ? "not-allowed" : "pointer",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.loading2FA ? (this.state.translations.verifying || 'Verificando...') : (this.state.translations.verify || 'Confirmar')}
                </button>
              </div>
            </div>
          </div>
        )}

      <ToastContainer />
    </section>
   );
  }
 }

export default Item;
